import {createSlice} from '@reduxjs/toolkit';

import storeSliceNames from '../../consts/storeSliceNames';

const initialState = {
    isDeviceInitialized: false,
    sharedSecret: null,
};

const sidewalkSlice = createSlice({
    name: storeSliceNames.sidewalk,
    initialState,
    reducers: {
        setIsDeviceInitialized(state, action) {
            state.isDeviceInitialized = action.payload;
        },
        setSharedSecret(state, action) {
            state.sharedSecret = action.payload;
        },
        resetSidewalkState() {
            return {...initialState};
        },
    },
});

export const setIsDeviceInitialized = (value) => sidewalkSlice.actions.setIsDeviceInitialized(value);
export const setSharedSecret = (value) => sidewalkSlice.actions.setSharedSecret(value);
export const resetSidewalkState = () => sidewalkSlice.actions.resetSidewalkState();

export default sidewalkSlice.reducer;
